import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import TeacherSelections from "../../../Reports/containers/TeacherSelections";
import getUserFilters from "../../../../services/Domo";
import { merge } from "lodash";
import * as request from "superagent";
import { TEACHER_LAYOUT } from "../../constants";

class AdminDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      config: {},
      filters: null,
      embedHtml: null,
    };
  }

  componentDidMount() {
    const { itemId } = this.props.match.params;
    this.requestDomoEmbed(itemId);
    this.applyPanelStyles(true);
  }

  componentWillUnmount() {
    this.applyPanelStyles(false);
  }

  componentDidUpdate(prevProps) {
    const { itemId } = this.props.match.params;

    if (this.props !== prevProps && itemId && itemId !== prevProps.match.params.itemId) {
      this.requestDomoEmbed(itemId);
    }
  }

  applyPanelStyles(apply) {
    const avatarPanels = document.querySelectorAll('div.rightPanel');
    const reportContainers = document.querySelectorAll('div.readerContainer.reportBox');

    avatarPanels.forEach(element => {
      if (apply) {
        // Hide the avatar panel only when this component is mounted.
        // Necessary so as not to hide this panel on all the other views/components.
        element.style.display = 'none';
        return;
      }

      element.removeAttribute('style');
    });

    reportContainers.forEach(element => {
      if (apply) {
        // Resize the report container panel when this component is mounted.
        element.style.width = '100%';
        return;
      }

      element.removeAttribute('style');
    })
  }

  async requestDomoEmbed(itemId) {
    if (itemId in this.state.config) {
      const config = this.state.config[itemId];
      const secondsSinceEpoch = Math.floor(Date.now() / 1000);

      if (config.expires && config.expires > secondsSinceEpoch) {
        // Reuse the existing token since it has not expired yet.
        this.setState({ embedHtml: this.generateEmbedHtml(config) });
      }

      return;
    }

    // The environment variable should be supplied with a value.
    const API_SERVER_URL = (process.env.DOMO_API_SERVER_URL && process.env.DOMO_API_SERVER_URL.length)
      ? `${process.env.DOMO_API_SERVER_URL}/domo/embed`
      : '';

    // Request a new embed token.
    request.post(API_SERVER_URL)
      .send({
        itemId,
        filters: await this.getFilters(),
      })
      .then(response => {
        const { body: config } = response;
        const newConfig = merge(this.state.config, { [itemId]: config });
        const embedHtml = this.generateEmbedHtml(config);

        this.setState({ config: newConfig, embedHtml });
      })
      .catch(e => console.error(`Error sending request to Domo: ${e.message}`))
  }

  generateEmbedHtml(config) {
    let queryString = '';
    let pfilters = [];
    let extraFilters = [];

    // Transform filters into something compatible with Domo's URL pfilters.
    // URL pfilters might appear redundant but this is used on cards (specially custom apps)
    // where programmatic filters may not be passed down to the cards.
    this.state.filters.forEach(element => {
      const { column, operator: operand, values } = element;
      pfilters.push({ column, operand, values });
      extraFilters.push(column);
    });

    // Additional filters to add to the filter view.
    ['school', 'grade', 'class', 'language']
      .filter(filter => (! extraFilters.includes(filter))) // Exclude what's already been added.
      .forEach(filter => pfilters.push({ column: filter, operand: 'IN', values: [] }));

    let filterQuery = JSON.stringify(pfilters);
    filterQuery = encodeURIComponent(filterQuery);
    //Need to encode ' specially because encodeURIComponent doesn't handle it
    filterQuery = filterQuery.replace(/'/g, "%27");

    if (pfilters.length) {
      queryString = `&pfilters=${filterQuery}`;
    }

    return `
    <html>
      <body>
        <form id="form" action='${config.embedUrl}${queryString}' method="post">
          <input type="hidden" name="embedToken" value='${config.embedToken}'>
        </form>
        <script>
          document.getElementById("form").submit();
        </script>
      </body>
    </html>`;
  }

  async getFilters() {
    if (! this.state.filters) {
      const filters = await getUserFilters();

      // Update the state adding the filters.
      this.setState({ filters });

      return filters;
    }

    return this.state.filters;
  }

  render() {
    const selectionProps = {
      pageTitle: "Admin Dashboard",
      disabledRostering: true,
    };

    return (
      <div className="reports-root-container">
        <div className="reports-page-wrap">
          <TeacherSelections
            layout={TEACHER_LAYOUT.content}
            teacherSelectionTypes={selectionProps}
            history={this.props.history}
            isAdminReport={true}
          />
          <div className="dashboardContainer">
            <div className="navContainer">
              <NavLink to={'/admin/dashboard/tracking'}>Tracking</NavLink>
              <NavLink to={'/admin/dashboard/growth'}>Growth</NavLink>
              <NavLink to={'/admin/dashboard/screening'}>Screening</NavLink>
              <NavLink to={'/admin/dashboard/sor'}>Science Of Reading</NavLink>
            </div>
            {
             this.state.embedHtml
             ? <iframe
              srcDoc={this.state.embedHtml}
              scrolling={'no'}>
              </iframe>
             : null
            }
          </div>
        </div>
      </div>
    );
  }
}

export default AdminDashboard;